import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import PageShell from '../components/PageShell';
import { PillInput, PillButton } from '../components/PillKit';

export default function PhoneVerifyPage() {
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [step, setStep] = useState('phone');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const sendCode = async (e) => {
    e.preventDefault();
    if (!phone.match(/^\+?[1-9]\d{6,14}$/)) return toast.error('Enter a valid phone number');
    setLoading(true);
    try {
      // TODO: wire to /api/auth/phone/send-code when Twilio is live
      await new Promise((r) => setTimeout(r, 800));
      toast.success('Code sent! (Twilio not yet configured)');
      setStep('code');
    } finally { setLoading(false); }
  };

  const verifyCode = async (e) => {
    e.preventDefault();
    if (code.length !== 6) return toast.error('Code must be 6 digits');
    setLoading(true);
    try {
      // TODO: wire to /api/auth/phone/verify
      await new Promise((r) => setTimeout(r, 800));
      toast.success('Phone verified!');
      navigate('/dashboard');
    } finally { setLoading(false); }
  };

  return (
    <PageShell
      testId="phone-verify-page"
      back
      title={step === 'phone'
        ? { line1: 'Your Phone', line2: 'Number' }
        : { line1: 'Enter the', line2: 'Code' }}
    >
      <p className="text-[#bbbbbb] text-sm leading-relaxed -mt-2 mb-8">
        {step === 'phone'
          ? "We'll text you a 6-digit verification code to confirm your phone number."
          : `We sent a 6-digit code to ${phone}. Enter it below to verify.`}
      </p>

      {step === 'phone' ? (
        <form onSubmit={sendCode} className="space-y-5 max-w-md">
          <PillInput
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="+1 (555) 555-5555"
            autoComplete="tel"
            data-testid="phone-input"
          />
          <PillButton onClick={sendCode} disabled={loading} data-testid="send-code-btn">
            {loading ? 'Sending…' : 'Send Code'}
          </PillButton>
        </form>
      ) : (
        <form onSubmit={verifyCode} className="space-y-5 max-w-md">
          <PillInput
            type="text"
            inputMode="numeric"
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
            placeholder="000000"
            autoComplete="one-time-code"
            className="text-3xl tracking-[0.5em] text-center"
            data-testid="code-input"
          />
          <PillButton onClick={verifyCode} disabled={loading} data-testid="verify-code-btn">
            {loading ? 'Verifying…' : 'Verify'}
          </PillButton>
          <button type="button" onClick={() => setStep('phone')} className="w-full text-white/60 text-sm hover:text-white" data-testid="change-phone-btn">
            Change phone number
          </button>
        </form>
      )}
    </PageShell>
  );
}
